import {
  Container,
  Grid,
  Stack,
  Modal,
  Typography,
  Box,
  TextField,
  Button,
} from "@mui/material";
import AppStoreImage from "../assets/Images/app_store.png";
import GooglePlayImage from "../assets/Images/google_play.png";
import Facebook from "../assets/Images/footer_facebook.png";
import Instagram from "../assets/Images/footer_instagram.png";
import Twitter from "../assets/Images/footer_twitter.png";
import React, { useState } from "react";
import { addQuery } from "../apis";
import { isMobile } from "react-device-detect";

const style = {
  position: "absolute",
  top: "25%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "white",
  p: 4,
};

const Footer = () => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [modalError, setModalError] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setEmail("");
    setTitle("");
    setDescription("");
    setModalError(false);
  };

  const contactUsClickHandler = () => {
    setOpen(true);
  };

  const querySubmitHandler = async () => {
    if (email == "" || title == "" || description == "") {
      setModalError(true);
      return;
    } else {
      let data = await addQuery({
        email: email,
        title: title,
        description: description,
      });
      if (data) {
        setOpen(false);
      }
      setModalError(false);
    }
  };
  if (isMobile) {
    return (
      <div>
        <footer class="site-footer">
          <Container maxWidth="xl">
            <Stack justifyContent="center" alignItems="center">
              <div>
                <h6 style={{ color: "black" }}>Get the app</h6>
                <ul class="footer-links">
                  <li>Amannat for Android</li>
                  <li>Amannat for iOS</li>
                  <li>Mobile site</li>
                  <li>
                    <a href="#" title="Google Play">
                      <img src={AppStoreImage} alt="App Store" />
                    </a>
                  </li>

                  <li>
                    <a href="#" title="Google Play">
                      <img src={GooglePlayImage} alt="Google Play" />
                    </a>
                  </li>
                </ul>
              </div>
            </Stack>
            <hr />
            <Stack>
              <p class="copyright-text">All Rights Reserved by Ammanat.</p>
            </Stack>
          </Container>
        </footer>
      </div>
    );
  } else {
    return (
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Stack spacing={2}>
              {modalError ? (
                <Stack>
                  <Typography style={{ color: "red" }}>
                    Please enter all of the required fields.
                  </Typography>
                </Stack>
              ) : (
                <></>
              )}

              <Stack>
                <Typography>Email</Typography>
                <TextField
                  size="small"
                  id="outlined-basic"
                  placeholder="Enter your email address"
                  variant="outlined"
                  className="w-100 mt-5"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Stack>
              <Stack>
                <Typography>Title</Typography>
                <TextField
                  size="small"
                  id="outlined-basic"
                  placeholder="Enter Title"
                  variant="outlined"
                  className="w-100 mt-5"
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Stack>
              <Stack>
                <Typography>Description</Typography>
                <TextField
                  multiline
                  rows={3}
                  size="small"
                  id="outlined-basic"
                  placeholder="Enter Description"
                  variant="outlined"
                  className="w-100 mt-5"
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Stack>
              <Stack direction="row" justifyContent="flex-end" spacing={2}>
                <Button
                  variant="outlined"
                  className="default-color default-border"
                  style={{ textTransform: "capitalize" }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  className="primary-button"
                  style={{ textTransform: "capitalize" }}
                  onClick={querySubmitHandler}
                >
                  Submit
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Modal>
        <footer class="site-footer">
          <Grid container className="footer" sm="12">
            {/* <Stack item spacing={2}>
                <div className="d-flex">
                  <span className="mr-7 mt-3">
                    {" "}
                    <img src={LifeSavoir} alt="MenuIcon" />
                  </span>
                  <h6> Life Saviour </h6>
                </div>
              </Stack> */}
            <Stack item>
              <div class="col-xs-6 col-md-3">
                <ul class="footer-links">
                  <li className="footerTitle">About</li>
                  <li className="footerList">About Amannat</li>
                  <li className="footerList">How it works</li>
                  <li className="footerList">Careers</li>
                  <li className="footerList">Press</li>
                  <li className="footerList">Blog</li>
                  <li className="footerList">Forum</li>
                </ul>
              </div>
            </Stack>
            <Stack item>
              <div class="col-xs-6 col-md-3">
                <ul class="footer-links">
                  <li className="footerTitle">Partner with us</li>
                  <li className="footerList">Partnership programs</li>
                  <li className="footerList">Affiliate program</li>
                  <li className="footerList">Connectivity partners</li>
                  <li className="footerList">Promotions and events</li>
                  <li className="footerList">Integrations</li>
                  <li className="footerList">Community</li>
                  <li className="footerList">Loyalty program</li>
                </ul>
              </div>
            </Stack>
            <Stack item>
              <div class="col-xs-6 col-md-3">
                <ul class="footer-links">
                  <li className="footerTitle">Support</li>
                  <li className="footerList">Help Center</li>
                  <li
                    onClick={contactUsClickHandler}
                    style={{ cursor: "pointer" }}
                    className="footerList"
                  >
                    Contact us
                  </li>
                  <li className="footerList">Privacy policy</li>
                  <li className="footerList">Terms of service</li>
                  <li className="footerList">Trust and safety</li>
                  <li className="footerList">Accessibility</li>
                </ul>
              </div>
            </Stack>
            <Stack item>
              <div class="col-xs-6 col-md-3">
                <ul class="footer-links">
                  <li className="footerTitle">Get the app</li>
                  <li className="footerList">Amannat for Android</li>
                  <li className="footerList">Amannat for iOS</li>
                  <li className="footerList">Mobile site</li>
                  <li className="footerList">
                    <a href="#" title="Google Play">
                      <img
                        src={AppStoreImage}
                        alt="App Store"
                        style={{ width: "135px", height: "40px" }}
                      />
                    </a>
                  </li>

                  <li className="footerList">
                    <a href="#" title="Google Play">
                      <img
                        src={GooglePlayImage}
                        alt="Google Play"
                        style={{ width: "135px", height: "40px" }}
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </Stack>
          </Grid>
          <div className="footer-line"></div>
          <Stack
            direction="row"
            justifyContent="space-between"
            style={{
              paddingTop: "30px",
              paddingBottom: "20px",
              paddingLeft: "5%",
              paddingRight: "5%",
            }}
          >
            <Stack direction="row" spacing={2}>
              <img
                src={Twitter}
                alt="Twitter Icon"
                style={{ width: "21px", height: "17px" }}
              />
              <img
                src={Instagram}
                alt="Instagram Icon"
                style={{ width: "20px", height: "20px" }}
              />
              <img
                src={Facebook}
                alt="Facebook Icon"
                style={{ width: "18px", height: "18px" }}
              />
            </Stack>
            <Stack>
              <p class="copyright-text" style={{ color: "#222222" }}>
                © 2022 Amannat Incoporated
              </p>
            </Stack>
          </Stack>
        </footer>
      </div>
    );
  }
};

export default Footer;
